// Import all category modules
import gettingStarted from './getting-started'
import companies from './companies'
import pointOfSale from './point-of-sale'
import cashRegisters from './cash-registers'
import workingRegister from './working-register'
import items from './items'
import categories from './categories'
import pricelist from './pricelist'
import associates from './associates'
import receipts from './receipts'
import reports from './reports'
import printers from './printers'
import warehouse from './warehouse'
import restaurant from './restaurant'
import caffeTemplate from './caffe-template'
import settings from './settings'
import glossary from './glossary'
import faq from './faq'

// Export all modules as array, sorted by order
const allCategories = [
  gettingStarted,
  companies,
  pointOfSale,
  cashRegisters,
  workingRegister,
  items,
  categories,
  pricelist,
  associates,
  receipts,
  reports,
  printers,
  warehouse,
  restaurant,
  caffeTemplate,
  settings,
  glossary,
  faq
]

// Filter only categories with show: true and sort by order
export default allCategories
  .filter(category => category.show)
  .sort((a, b) => a.order - b.order)
